module.exports = __webpack_public_path__ + "static/media/stop_sign.e182a45c.svg";